<template>
	<AppPage
		:class="filedropper.isDroppingFiles.value ? 'dropping-files' : ''"
		@drop.prevent="filedropper.onFileDrop"
		@dragover.prevent="filedropper.startFileDrop"
		@dragenter.prevent="filedropper.startFileDrop"
		@dragleave.prevent="filedropper.endFileDrop"
	>
		<AppOverlay v-if="filedropper.isDroppingFiles.value" />
		<AppPageTitle>
			<h2>Documenten</h2>
			<div class="end">
				<AppButton
					v-if="fileDownloadButtonText"
					:loading="fileDownloader.isLoading.value"
					icon="download"
					variant="secondary"
					@click="fileDownloader.run"
				>
					{{ fileDownloadButtonText }}
				</AppButton>
				<AppButton as="label" variant="primary" icon="add" :for="uploaderId">
					Nieuw document
				</AppButton>
			</div>
		</AppPageTitle>
		<AppCardPage>
			<FileOverviewLayout :uploader-id />
		</AppCardPage>
	</AppPage>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useWaiter } from "@/composables/useWaiter";
import { useFileUploadStore } from "@/store/useFileUploadStore";
import { useFiledropper } from "@/composables/useFiledropper";

const uploaderId = crypto.randomUUID();
const fileUploadStore = useFileUploadStore();

const filedropper = useFiledropper({
	handleFileDrop: (file: File) => {
		fileUploadStore.addToFilesToUpload(file);
	},
});

const fileDownloader = useWaiter(() => fileUploadStore.downloadFiles());

const fileDownloadButtonText = computed(() => {
	const selectedFileCount = fileUploadStore.selectedFromExistingFiles.length;

	if (selectedFileCount === 1) {
		return "1 document downloaden";
	}
	if (selectedFileCount >= 2) {
		return `${selectedFileCount} documenten downloaden`;
	}
	return "Alles downloaden";
});
</script>

<style lang="scss">
#add-files-buttons {
	align-self: center;
	margin-top: 1.25rem;
	display: flex;
	flex-direction: row;
	column-gap: 1.25rem;
}

.files-to-upload {
	padding: 0;
	width: 100%;
	max-width: 600px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	row-gap: 1.25rem;
}

.dropping-files {
	z-index: 2000;
	outline: 1rem solid var(--color-success);
	outline-offset: -1rem;

	.file-drop-outlined {
		outline: 0.25rem dashed var(--color-success);
		outline-offset: -0.5rem;
	}
}

.separator {
	width: 50%;
	border: none;
	border-bottom: 1px solid var(--border);
	margin: 1.25rem auto 0;
}
</style>
